import React from 'react'
import styled from 'styled-components'
import { DESKTOP } from '@streamr/streamr-layout/styled'
import RoundedBox from '../RoundedBox'
import network1 from './assets/network-1.png'
import network12x from './assets/network-1@2x.png'
import network2 from './assets/network-2.png'
import network22x from './assets/network-2@2x.png'
import network3 from './assets/network-3.png'
import network32x from './assets/network-3@2x.png'
import network4 from './assets/network-4.png'
import network42x from './assets/network-4@2x.png'
import Topic from '~shared/Topic'

const IconContainer = styled.div`
    position: relative;
    width: 200px;
    height: 200px;

    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    @media (min-width: ${DESKTOP}px) {
        width: 400px;
        height: 400px;
    }
`

const Slide1 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Network overview
            </Topic.Title>
            <Topic.Paragraph>
                Applications publishing or subscribing to data streams interact with the network via Broker nodes.
                Apps interface with nodes using simple standard protocols like MQTT, HTTP, and websockets,
                making integration easy from any programming language. The node also runs natively inside JS-based applications.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={network1} srcSet={network12x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide2 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Network overview
            </Topic.Title>
            <Topic.Paragraph>
                To allow applications to interact with a stream,
                the node joins it by connecting to a number of other nodes that have already joined the stream.
                Each node that has joined a stream relays messages to other connected nodes under the rules of the protocol.
                This means that every node that receives particular data also helps distribute it onwards,
                making the network scale extremely well.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={network2} srcSet={network22x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide3 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Network overview
            </Topic.Title>
            <Topic.Paragraph>
                Messages that are not intended to be public are end-to-end encrypted,
                and can only be decrypted by a set of recipients controlled by the publisher.
                Each published message is also signed with the publisher’s private key, making tampering of the data impossible.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={network3} srcSet={network32x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const Slide4 = (props) => (
    <RoundedBox.Inner {...props}>
        <RoundedBox.Content>
            <Topic.Title>
                Network overview
            </Topic.Title>
            <Topic.Paragraph>
                The Streamr Network works alongside the Ethereum blockchain and uses its identity system.
                Users are represented by Ethereum addresses and authenticated by private keys.
                Ethereum smart contracts are used to maintain and secure the registry of permissions associated with streams,
                and the DATA token is used to to pay Broker nodes for securing and scaling streams on the network.
            </Topic.Paragraph>
        </RoundedBox.Content>
        <RoundedBox.Icon>
            <IconContainer>
                <img src={network4} srcSet={network42x} alt="" />
            </IconContainer>
        </RoundedBox.Icon>
    </RoundedBox.Inner>
)

const NetworkOverview = () => (
    <RoundedBox.Gallery items={[Slide1, Slide2, Slide3, Slide4]} />
)

export default NetworkOverview
